import React from 'react';
import HomeProducts from '../../Shared/Home Products/HomeProducts';
import About from '../About/About';
import Banner from '../Banner/Banner';
import Footer from '../Footer/Footer';
import Reviews from '../Reviews/Reviews/Reviews';
// import ChatBot from './ChatBot/ChatBot';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <HomeProducts></HomeProducts>
            <About></About>
            <Reviews></Reviews>
            <Footer></Footer>
            {/* <ChatBot /> Add this at the end */}
        </div>
    );
};

export default Home;